import React from 'react';
import { FadeIn } from './FadeIn';
const steps = [{
  number: '01',
  title: 'Identify the Voltage',
  description: 'Look at your child—are they fast, steady, or slowing down?'
}, {
  number: '02',
  title: 'Flip to the Chapter',
  description: 'Choose an activity from the corresponding Energy Filter.'
}, {
  number: '03',
  title: 'The Silent Invitation',
  description: 'Set up the "2-minute hack" and walk away to start your dinner.'
}];
export function HowItWorks() {
  return <section className="bg-cream py-24 sm:py-32" data-id="element-154">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-155">
        <div className="mx-auto max-w-2xl text-center mb-20" data-id="element-156">
          <FadeIn data-id="element-157">
            <h2 className="font-serif text-3xl font-bold tracking-tight text-navy sm:text-4xl" data-id="element-158">
              How It Works
            </h2>
          </FadeIn>
        </div>

        <div className="mx-auto max-w-5xl" data-id="element-159">
          <div className="relative" data-id="element-160">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-12 left-12 right-12 h-0.5 bg-amber-light z-0" data-id="element-161" />

            <div className="grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-8 relative z-10" data-id="element-162">
              {steps.map((step, index) => <FadeIn key={step.number} delay={index * 0.2} direction="up" data-id="element-163">
                  <div className="relative flex flex-col items-center text-center" data-id="element-164">
                    <div className="flex h-24 w-24 items-center justify-center rounded-full bg-white shadow-soft border-4 border-cream mb-6" data-id="element-165">
                      <span className="font-serif text-3xl font-bold text-amber" data-id="element-166">
                        {step.number}
                      </span>
                    </div>
                    <h3 className="text-xl font-bold text-navy mb-3" data-id="element-167">
                      {step.title}
                    </h3>
                    <p className="text-muted leading-relaxed max-w-xs" data-id="element-168">
                      {step.description}
                    </p>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}